.container {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  margin-top: 8px;
  margin-bottom: 8px;
  border-style: solid;
  border-color: var(--tuna-palette-divider);
  background-color: var(--tuna-palette-action-hover);
  border-width: 1px;
  border-radius: 8px;
}

.avatar {
  margin-right: 8px;
}

.editor {
  flex: 1;
  flex-direction: column;
  padding: 0 8px;
  display: flex;
  justify-content: center;
}
